<template>
  <v-container>
    <v-overlay :value="loading">
        <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RC_SITE_KEY });


export default {
  components: { },

  computed: {
    company: {
      get() {
        return this.$store.state.company;
      },
      set(value) {
        this.$store.commit("setCompany", { company: value });
      }
    },
    location: {
      get() {
        return this.$store.state.location;
      },
      set(value) {
        this.$store.commit("setLocation", { location: value });
      },
    },
    locations: {
      get() {
        return this.$store.state.locations;
      },
      set(value) {
        this.$store.commit("setLocations", { locations: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      }
    }
  },

  data: () => ({
  }),
  props: {
    source: String
  },

  methods: {
    async formSubmit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        const token = await this.getRecaptchaToken('leadForm');
        let currentObj = this;
        axios
          .post(process.env.VUE_APP_LEAD_API + `?rc=${token}`, this.$store.state)
          .then(response => {
            currentObj.output = response.data;
            this.$router.push({ name: "Success" });
          })
          .catch(error => {
            console.log("There was an error:", error.response);
            currentObj.output = error;
          });
      }
    },
    async getCompany() {
      this.loading = true;
      const token = await this.getRecaptchaToken('getCompany');
      axios
        .get(
          process.env.VUE_APP_COMPANY_API +
            this.$route.params.location + `?rc=${token}`
        )
        .then(response => {
          this.company = response.data.company;
          this.company.location = `${response.data.company.hiring_company_name}, ${response.data.company.state}`;
          if (this.company.is_hiring_party) {
            console.log('is hiring party!')
            this.locations.push(this.$route.params.location)
            this.$router.push({ name: "Lead" });
            return false
          }
          if (this.company.workday_url) {
            if (this.company.is_hiring) {
              window.location.replace(this.company.workday_url)
              return false
            }
            else {
             this.$router.push({ name: "Home" });
             return
            }
          }
          this.locations = []
          if (this.$route.params.location.length === 4) {
            this.locations.push(this.company.db_company_id)
          } else {
            this.locations.push(this.$route.params.location)
          }
          this.$router.push({ name: "P1" });
        })
        .catch(error => {
          console.log("There was an error:", error.response);
          this.$router.push({ name: "Home" });
        });
      this.loading = false;
    },
    async getRecaptchaToken(action) {
      await this.$recaptchaLoaded()
      return await this.$recaptcha(action)
    },
  },

  async created() {
    window.localStorage.clear();
    await this.getCompany();
  }

};
</script>
